// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

// This was generated using spacetimedb cli version 2.14.0 (commit 3ac273e970212dd613e57f4c312c49a9ab8ccb50).

/* eslint-disable */
/* tslint:disable */
import {
  DbConnectionBuilder as __DbConnectionBuilder,
  DbConnectionImpl as __DbConnectionImpl,
  SubscriptionBuilderImpl as __SubscriptionBuilderImpl,
  TypeBuilder as __TypeBuilder,
  Uuid as __Uuid,
  convertToAccessorMap as __convertToAccessorMap,
  makeQueryBuilder as __makeQueryBuilder,
  procedureSchema as __procedureSchema,
  procedures as __procedures,
  reducerSchema as __reducerSchema,
  reducers as __reducers,
  schema as __schema,
  t as __t,
  table as __table,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type DbConnectionConfig as __DbConnectionConfig,
  type ErrorContextInterface as __ErrorContextInterface,
  type Event as __Event,
  type EventContextInterface as __EventContextInterface,
  type Infer as __Infer,
  type QueryBuilder as __QueryBuilder,
  type ReducerEventContextInterface as __ReducerEventContextInterface,
  type RemoteModule as __RemoteModule,
  type SubscriptionEventContextInterface as __SubscriptionEventContextInterface,
  type SubscriptionHandleImpl as __SubscriptionHandleImpl,
} from "spacetimedb";

// Import all reducer arg schemas
import AssignUserRoleReducer from "./assign_user_role_reducer";
import BackfillCanonicalHierarchyReducer from "./backfill_canonical_hierarchy_reducer";
import BackfillRenditionsReducer from "./backfill_renditions_reducer";
import ClaimProjectScopeReducer from "./claim_project_scope_reducer";
import ClearLegacyBlobUrlsReducer from "./clear_legacy_blob_urls_reducer";
import ClearRenditionPreferenceReducer from "./clear_rendition_preference_reducer";
import CompleteAssetIngestionReducer from "./complete_asset_ingestion_reducer";
import CompleteAssetUploadProgressReducer from "./complete_asset_upload_progress_reducer";
import CompleteRenderReducer from "./complete_render_reducer";
import CreateAssetReducer from "./create_asset_reducer";
import CreateAssetUploadProgressReducer from "./create_asset_upload_progress_reducer";
import CreateRenditionReducer from "./create_rendition_reducer";
import CreateRenditionVersionReducer from "./create_rendition_version_reducer";
import CreateVersionReducer from "./create_version_reducer";
import DeleteRenderReducer from "./delete_render_reducer";
import DeprecateVersionReducer from "./deprecate_version_reducer";
import DropAssetScopeReducer from "./drop_asset_scope_reducer";
import DropProjectScopeReducer from "./drop_project_scope_reducer";
import FinalizePublishReducer from "./finalize_publish_reducer";
import GetModuleInfoReducer from "./get_module_info_reducer";
import ModuleUpdateReducer from "./module_update_reducer";
import PostRestoreNormalizeReducer from "./post_restore_normalize_reducer";
import RegisterAdminServiceReducer from "./register_admin_service_reducer";
import RegisterAssetMetadataReducer from "./register_asset_metadata_reducer";
import RegisterAssetSceneNodeReducer from "./register_asset_scene_node_reducer";
import RegisterFileReducer from "./register_file_reducer";
import RegisterOrgAdminServiceReducer from "./register_org_admin_service_reducer";
import RemoveAssetAttributeReducer from "./remove_asset_attribute_reducer";
import RemoveAssetScopeGrantReducer from "./remove_asset_scope_grant_reducer";
import RemoveModuleUserReducer from "./remove_module_user_reducer";
import RemoveOrgModuleUserReducer from "./remove_org_module_user_reducer";
import ReportIngestionProgressReducer from "./report_ingestion_progress_reducer";
import SetAssetAttributeReducer from "./set_asset_attribute_reducer";
import SetAssetBoundsReducer from "./set_asset_bounds_reducer";
import SetAssetDispatchConfigReducer from "./set_asset_dispatch_config_reducer";
import SetAssetPlacementReducer from "./set_asset_placement_reducer";
import SetAssetScopeGrantReducer from "./set_asset_scope_grant_reducer";
import SetAssetStorageConfigReducer from "./set_asset_storage_config_reducer";
import SetAssetThumbnailReducer from "./set_asset_thumbnail_reducer";
import SetCurrentVersionReducer from "./set_current_version_reducer";
import SetFileDownloadUrlReducer from "./set_file_download_url_reducer";
import SetInfraBrokerConfigReducer from "./set_infra_broker_config_reducer";
import SetIngestionJobDurationReducer from "./set_ingestion_job_duration_reducer";
import SetModuleUserRoleReducer from "./set_module_user_role_reducer";
import SetOrgModuleUserRoleReducer from "./set_org_module_user_role_reducer";
import SetProjectScopeReducer from "./set_project_scope_reducer";
import SetProjectTenantConfigReducer from "./set_project_tenant_config_reducer";
import SetRenditionBoundsReducer from "./set_rendition_bounds_reducer";
import SetRenditionFootprintReducer from "./set_rendition_footprint_reducer";
import SetRenditionGeoreferenceReducer from "./set_rendition_georeference_reducer";
import SetRenditionImportSettingsReducer from "./set_rendition_import_settings_reducer";
import SetRenditionPreferenceReducer from "./set_rendition_preference_reducer";
import SetRenditionTransformReducer from "./set_rendition_transform_reducer";
import SetReportUsageConfigReducer from "./set_report_usage_config_reducer";
import SetWorkosOrgIdReducer from "./set_workos_org_id_reducer";
import TransferAdminServiceReducer from "./transfer_admin_service_reducer";
import TransferOrgAdminServiceReducer from "./transfer_org_admin_service_reducer";
import TransferWorkosOrgIdReducer from "./transfer_workos_org_id_reducer";
import UpdateAssetReducer from "./update_asset_reducer";
import UpdateAssetUploadProgressReducer from "./update_asset_upload_progress_reducer";
import UpdateUsernameReducer from "./update_username_reducer";

// Import all procedure arg schemas
import * as AdminListAssetsProcedure from "./admin_list_assets_procedure";
import * as DeleteAssetProcedure from "./delete_asset_procedure";
import * as DeleteRenditionProcedure from "./delete_rendition_procedure";
import * as GetAssetDetailProcedure from "./get_asset_detail_procedure";
import * as GetAssetDownloadUrlProcedure from "./get_asset_download_url_procedure";
import * as GetAssetUploadUrlProcedure from "./get_asset_upload_url_procedure";
import * as GetAssetUploadUrlsProcedure from "./get_asset_upload_urls_procedure";
import * as GetBlobDownloadUrlProcedure from "./get_blob_download_url_procedure";
import * as GetBlobDownloadUrlsProcedure from "./get_blob_download_urls_procedure";
import * as GetRenderUploadUrlProcedure from "./get_render_upload_url_procedure";
import * as RequestAssetIngestionProcedure from "./request_asset_ingestion_procedure";
import * as RequestRenderProcedure from "./request_render_procedure";
import * as RequestRenderDownloadUrlProcedure from "./request_render_download_url_procedure";

// Import all table schema definitions
import AssetAttributeRow from "./asset_attribute_table";
import AssetCanonicalNodeRow from "./asset_canonical_node_table";
import AssetChunkHashIndexRow from "./asset_chunk_hash_index_table";
import AssetChunkStoreRow from "./asset_chunk_store_table";
import AssetCreatedEventRow from "./asset_created_event_table";
import AssetFileChunkRefRow from "./asset_file_chunk_ref_table";
import AssetFileRegisteredEventRow from "./asset_file_registered_event_table";
import AssetIngestionCompletedEventRow from "./asset_ingestion_completed_event_table";
import AssetMetadataRow from "./asset_metadata_table";
import AssetRenditionCreatedEventRow from "./asset_rendition_created_event_table";
import AssetRenditionNodeRow from "./asset_rendition_node_table";
import AssetSceneNodeRow from "./asset_scene_node_table";
import AssetScopeGrantRow from "./asset_scope_grant_table";
import AssetUploadCompletedEventRow from "./asset_upload_completed_event_table";
import AssetUploadProgressCreatedEventRow from "./asset_upload_progress_created_event_table";
import AssetUserRow from "./asset_user_table";
import AssetVersionCreatedEventRow from "./asset_version_created_event_table";
import ModuleUserRow from "./module_user_table";
import MyAssetRow from "./my_asset_table";
import MyAssetFileRow from "./my_asset_file_table";
import MyAssetImportSettingsRow from "./my_asset_import_settings_table";
import MyAssetIngestionRequestsRow from "./my_asset_ingestion_requests_table";
import MyAssetRenditionRow from "./my_asset_rendition_table";
import MyAssetUploadProgressRow from "./my_asset_upload_progress_table";
import MyAssetVersionRow from "./my_asset_version_table";
import MyCurrentVersionRow from "./my_current_version_table";
import OrgModuleUserRow from "./org_module_user_table";
import RenderJobRow from "./render_job_table";
import RenditionPreferenceRow from "./rendition_preference_table";

/** Type-only namespace exports for generated type groups. */

/** The schema information for all tables in this module. This is defined the same was as the tables would have been defined in the server. */
const tablesSchema = __schema({
  assetAttribute: __table({
    name: 'asset_attribute',
    indexes: [
      { accessor: 'asset_id', name: 'asset_attribute_asset_id_idx_btree', algorithm: 'btree', columns: [
        'assetId',
      ] },
      { accessor: 'attribute_id', name: 'asset_attribute_attribute_id_idx_btree', algorithm: 'btree', columns: [
        'attributeId',
      ] },
    ],
    constraints: [
      { name: 'asset_attribute_attribute_id_key', constraint: 'unique', columns: ['attributeId'] },
    ],
  }, AssetAttributeRow),
  assetCanonicalNode: __table({
    name: 'asset_canonical_node',
    indexes: [
      { accessor: 'asset_id', name: 'asset_canonical_node_asset_id_idx_btree', algorithm: 'btree', columns: [
        'assetId',
      ] },
      { accessor: 'canonical_id', name: 'asset_canonical_node_canonical_id_idx_btree', algorithm: 'btree', columns: [
        'canonicalId',
      ] },
      { accessor: 'row_id', name: 'asset_canonical_node_row_id_idx_btree', algorithm: 'btree', columns: [
        'rowId',
      ] },
    ],
    constraints: [
      { name: 'asset_canonical_node_row_id_key', constraint: 'unique', columns: ['rowId'] },
    ],
  }, AssetCanonicalNodeRow),
  assetChunkHashIndex: __table({
    name: 'asset_chunk_hash_index',
    indexes: [
      { accessor: 'hash', name: 'asset_chunk_hash_index_hash_idx_btree', algorithm: 'btree', columns: [
        'hash',
      ] },
    ],
    constraints: [
      { name: 'asset_chunk_hash_index_hash_key', constraint: 'unique', columns: ['hash'] },
    ],
  }, AssetChunkHashIndexRow),
  assetChunkStore: __table({
    name: 'asset_chunk_store',
    indexes: [
      { accessor: 'hash', name: 'asset_chunk_store_hash_idx_btree', algorithm: 'btree', columns: [
        'hash',
      ] },
    ],
    constraints: [
      { name: 'asset_chunk_store_hash_key', constraint: 'unique', columns: ['hash'] },
    ],
  }, AssetChunkStoreRow),
  assetCreatedEvent: __table({
    name: 'asset_created_event',
    indexes: [
    ],
    constraints: [
    ],
    event: true,
  }, AssetCreatedEventRow),
  assetFileChunkRef: __table({
    name: 'asset_file_chunk_ref',
    indexes: [
      { accessor: 'file_id', name: 'asset_file_chunk_ref_file_id_idx_btree', algorithm: 'btree', columns: [
        'fileId',
      ] },
      { accessor: 'ref_id', name: 'asset_file_chunk_ref_ref_id_idx_btree', algorithm: 'btree', columns: [
        'refId',
      ] },
    ],
    constraints: [
      { name: 'asset_file_chunk_ref_ref_id_key', constraint: 'unique', columns: ['refId'] },
    ],
  }, AssetFileChunkRefRow),
  assetFileRegisteredEvent: __table({
    name: 'asset_file_registered_event',
    indexes: [
    ],
    constraints: [
    ],
    event: true,
  }, AssetFileRegisteredEventRow),
  assetIngestionCompletedEvent: __table({
    name: 'asset_ingestion_completed_event',
    indexes: [
    ],
    constraints: [
    ],
    event: true,
  }, AssetIngestionCompletedEventRow),
  assetMetadata: __table({
    name: 'asset_metadata',
    indexes: [
      { accessor: 'file_id', name: 'asset_metadata_file_id_idx_btree', algorithm: 'btree', columns: [
        'fileId',
      ] },
      { accessor: 'metadata_id', name: 'asset_metadata_metadata_id_idx_btree', algorithm: 'btree', columns: [
        'metadataId',
      ] },
      { accessor: 'version_id', name: 'asset_metadata_version_id_idx_btree', algorithm: 'btree', columns: [
        'versionId',
      ] },
    ],
    constraints: [
      { name: 'asset_metadata_metadata_id_key', constraint: 'unique', columns: ['metadataId'] },
    ],
  }, AssetMetadataRow),
  assetRenditionCreatedEvent: __table({
    name: 'asset_rendition_created_event',
    indexes: [
    ],
    constraints: [
    ],
    event: true,
  }, AssetRenditionCreatedEventRow),
  assetRenditionNode: __table({
    name: 'asset_rendition_node',
    indexes: [
      { accessor: 'asset_id', name: 'asset_rendition_node_asset_id_idx_btree', algorithm: 'btree', columns: [
        'assetId',
      ] },
      { accessor: 'canonical_id', name: 'asset_rendition_node_canonical_id_idx_btree', algorithm: 'btree', columns: [
        'canonicalId',
      ] },
      { accessor: 'rendition_id', name: 'asset_rendition_node_rendition_id_idx_btree', algorithm: 'btree', columns: [
        'renditionId',
      ] },
      { accessor: 'row_id', name: 'asset_rendition_node_row_id_idx_btree', algorithm: 'btree', columns: [
        'rowId',
      ] },
    ],
    constraints: [
      { name: 'asset_rendition_node_row_id_key', constraint: 'unique', columns: ['rowId'] },
    ],
  }, AssetRenditionNodeRow),
  assetSceneNode: __table({
    name: 'asset_scene_node',
    indexes: [
      { accessor: 'file_id', name: 'asset_scene_node_file_id_idx_btree', algorithm: 'btree', columns: [
        'fileId',
      ] },
      { accessor: 'node_id', name: 'asset_scene_node_node_id_idx_btree', algorithm: 'btree', columns: [
        'nodeId',
      ] },
      { accessor: 'version_id', name: 'asset_scene_node_version_id_idx_btree', algorithm: 'btree', columns: [
        'versionId',
      ] },
    ],
    constraints: [
      { name: 'asset_scene_node_node_id_key', constraint: 'unique', columns: ['nodeId'] },
    ],
  }, AssetSceneNodeRow),
  assetScopeGrant: __table({
    name: 'asset_scope_grant',
    indexes: [
      { accessor: 'grant_id', name: 'asset_scope_grant_grant_id_idx_btree', algorithm: 'btree', columns: [
        'grantId',
      ] },
      { accessor: 'identity', name: 'asset_scope_grant_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
      { accessor: 'scope', name: 'asset_scope_grant_scope_idx_btree', algorithm: 'btree', columns: [
        'scope',
      ] },
    ],
    constraints: [
      { name: 'asset_scope_grant_grant_id_key', constraint: 'unique', columns: ['grantId'] },
    ],
  }, AssetScopeGrantRow),
  assetUploadCompletedEvent: __table({
    name: 'asset_upload_completed_event',
    indexes: [
    ],
    constraints: [
    ],
    event: true,
  }, AssetUploadCompletedEventRow),
  assetUploadProgressCreatedEvent: __table({
    name: 'asset_upload_progress_created_event',
    indexes: [
    ],
    constraints: [
    ],
    event: true,
  }, AssetUploadProgressCreatedEventRow),
  assetUser: __table({
    name: 'asset_user',
    indexes: [
      { accessor: 'identity', name: 'asset_user_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'asset_user_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, AssetUserRow),
  assetVersionCreatedEvent: __table({
    name: 'asset_version_created_event',
    indexes: [
    ],
    constraints: [
    ],
    event: true,
  }, AssetVersionCreatedEventRow),
  moduleUser: __table({
    name: 'module_user',
    indexes: [
      { accessor: 'identity', name: 'module_user_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'module_user_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, ModuleUserRow),
  orgModuleUser: __table({
    name: 'org_module_user',
    indexes: [
      { accessor: 'identity', name: 'org_module_user_identity_idx_btree', algorithm: 'btree', columns: [
        'identity',
      ] },
    ],
    constraints: [
      { name: 'org_module_user_identity_key', constraint: 'unique', columns: ['identity'] },
    ],
  }, OrgModuleUserRow),
  renderJob: __table({
    name: 'render_job',
    indexes: [
      { accessor: 'id', name: 'render_job_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
      { accessor: 'project', name: 'render_job_project_idx_btree', algorithm: 'btree', columns: [
        'project',
      ] },
      { accessor: 'requested_by', name: 'render_job_requested_by_idx_btree', algorithm: 'btree', columns: [
        'requestedBy',
      ] },
    ],
    constraints: [
      { name: 'render_job_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, RenderJobRow),
  renditionPreference: __table({
    name: 'rendition_preference',
    indexes: [
      { accessor: 'client_type', name: 'rendition_preference_client_type_idx_btree', algorithm: 'btree', columns: [
        'clientType',
      ] },
    ],
    constraints: [
      { name: 'rendition_preference_client_type_key', constraint: 'unique', columns: ['clientType'] },
    ],
  }, RenditionPreferenceRow),
  myAsset: __table({
    name: 'my_asset',
    indexes: [
    ],
    constraints: [
    ],
  }, MyAssetRow),
  myAssetFile: __table({
    name: 'my_asset_file',
    indexes: [
    ],
    constraints: [
    ],
  }, MyAssetFileRow),
  myAssetImportSettings: __table({
    name: 'my_asset_import_settings',
    indexes: [
    ],
    constraints: [
    ],
  }, MyAssetImportSettingsRow),
  myAssetIngestionRequests: __table({
    name: 'my_asset_ingestion_requests',
    indexes: [
    ],
    constraints: [
    ],
  }, MyAssetIngestionRequestsRow),
  myAssetRendition: __table({
    name: 'my_asset_rendition',
    indexes: [
    ],
    constraints: [
    ],
  }, MyAssetRenditionRow),
  myAssetUploadProgress: __table({
    name: 'my_asset_upload_progress',
    indexes: [
    ],
    constraints: [
    ],
  }, MyAssetUploadProgressRow),
  myAssetVersion: __table({
    name: 'my_asset_version',
    indexes: [
    ],
    constraints: [
    ],
  }, MyAssetVersionRow),
  myCurrentVersion: __table({
    name: 'my_current_version',
    indexes: [
    ],
    constraints: [
    ],
  }, MyCurrentVersionRow),
});

/** The schema information for all reducers in this module. This is defined the same way as the reducers would have been defined in the server, except the body of the reducer is omitted in code generation. */
const reducersSchema = __reducers(
  __reducerSchema("assign_user_role", AssignUserRoleReducer),
  __reducerSchema("backfill_canonical_hierarchy", BackfillCanonicalHierarchyReducer),
  __reducerSchema("backfill_renditions", BackfillRenditionsReducer),
  __reducerSchema("claim_project_scope", ClaimProjectScopeReducer),
  __reducerSchema("clear_legacy_blob_urls", ClearLegacyBlobUrlsReducer),
  __reducerSchema("clear_rendition_preference", ClearRenditionPreferenceReducer),
  __reducerSchema("complete_asset_ingestion", CompleteAssetIngestionReducer),
  __reducerSchema("complete_asset_upload_progress", CompleteAssetUploadProgressReducer),
  __reducerSchema("complete_render", CompleteRenderReducer),
  __reducerSchema("create_asset", CreateAssetReducer),
  __reducerSchema("create_asset_upload_progress", CreateAssetUploadProgressReducer),
  __reducerSchema("create_rendition", CreateRenditionReducer),
  __reducerSchema("create_rendition_version", CreateRenditionVersionReducer),
  __reducerSchema("create_version", CreateVersionReducer),
  __reducerSchema("delete_render", DeleteRenderReducer),
  __reducerSchema("deprecate_version", DeprecateVersionReducer),
  __reducerSchema("drop_asset_scope", DropAssetScopeReducer),
  __reducerSchema("drop_project_scope", DropProjectScopeReducer),
  __reducerSchema("finalize_publish", FinalizePublishReducer),
  __reducerSchema("get_module_info", GetModuleInfoReducer),
  __reducerSchema("module_update", ModuleUpdateReducer),
  __reducerSchema("post_restore_normalize", PostRestoreNormalizeReducer),
  __reducerSchema("register_admin_service", RegisterAdminServiceReducer),
  __reducerSchema("register_asset_metadata", RegisterAssetMetadataReducer),
  __reducerSchema("register_asset_scene_node", RegisterAssetSceneNodeReducer),
  __reducerSchema("register_file", RegisterFileReducer),
  __reducerSchema("register_org_admin_service", RegisterOrgAdminServiceReducer),
  __reducerSchema("remove_asset_attribute", RemoveAssetAttributeReducer),
  __reducerSchema("remove_asset_scope_grant", RemoveAssetScopeGrantReducer),
  __reducerSchema("remove_module_user", RemoveModuleUserReducer),
  __reducerSchema("remove_org_module_user", RemoveOrgModuleUserReducer),
  __reducerSchema("report_ingestion_progress", ReportIngestionProgressReducer),
  __reducerSchema("set_asset_attribute", SetAssetAttributeReducer),
  __reducerSchema("set_asset_bounds", SetAssetBoundsReducer),
  __reducerSchema("set_asset_dispatch_config", SetAssetDispatchConfigReducer),
  __reducerSchema("set_asset_placement", SetAssetPlacementReducer),
  __reducerSchema("set_asset_scope_grant", SetAssetScopeGrantReducer),
  __reducerSchema("set_asset_storage_config", SetAssetStorageConfigReducer),
  __reducerSchema("set_asset_thumbnail", SetAssetThumbnailReducer),
  __reducerSchema("set_current_version", SetCurrentVersionReducer),
  __reducerSchema("set_file_download_url", SetFileDownloadUrlReducer),
  __reducerSchema("set_infra_broker_config", SetInfraBrokerConfigReducer),
  __reducerSchema("set_ingestion_job_duration", SetIngestionJobDurationReducer),
  __reducerSchema("set_module_user_role", SetModuleUserRoleReducer),
  __reducerSchema("set_org_module_user_role", SetOrgModuleUserRoleReducer),
  __reducerSchema("set_project_scope", SetProjectScopeReducer),
  __reducerSchema("set_project_tenant_config", SetProjectTenantConfigReducer),
  __reducerSchema("set_rendition_bounds", SetRenditionBoundsReducer),
  __reducerSchema("set_rendition_footprint", SetRenditionFootprintReducer),
  __reducerSchema("set_rendition_georeference", SetRenditionGeoreferenceReducer),
  __reducerSchema("set_rendition_import_settings", SetRenditionImportSettingsReducer),
  __reducerSchema("set_rendition_preference", SetRenditionPreferenceReducer),
  __reducerSchema("set_rendition_transform", SetRenditionTransformReducer),
  __reducerSchema("set_report_usage_config", SetReportUsageConfigReducer),
  __reducerSchema("set_workos_org_id", SetWorkosOrgIdReducer),
  __reducerSchema("transfer_admin_service", TransferAdminServiceReducer),
  __reducerSchema("transfer_org_admin_service", TransferOrgAdminServiceReducer),
  __reducerSchema("transfer_workos_org_id", TransferWorkosOrgIdReducer),
  __reducerSchema("update_asset", UpdateAssetReducer),
  __reducerSchema("update_asset_upload_progress", UpdateAssetUploadProgressReducer),
  __reducerSchema("update_username", UpdateUsernameReducer),
);

/** The schema information for all procedures in this module. This is defined the same way as the procedures would have been defined in the server. */
const proceduresSchema = __procedures(
  __procedureSchema("admin_list_assets", AdminListAssetsProcedure.params, AdminListAssetsProcedure.returnType),
  __procedureSchema("delete_asset", DeleteAssetProcedure.params, DeleteAssetProcedure.returnType),
  __procedureSchema("delete_rendition", DeleteRenditionProcedure.params, DeleteRenditionProcedure.returnType),
  __procedureSchema("get_asset_detail", GetAssetDetailProcedure.params, GetAssetDetailProcedure.returnType),
  __procedureSchema("get_asset_download_url", GetAssetDownloadUrlProcedure.params, GetAssetDownloadUrlProcedure.returnType),
  __procedureSchema("get_asset_upload_url", GetAssetUploadUrlProcedure.params, GetAssetUploadUrlProcedure.returnType),
  __procedureSchema("get_asset_upload_urls", GetAssetUploadUrlsProcedure.params, GetAssetUploadUrlsProcedure.returnType),
  __procedureSchema("get_blob_download_url", GetBlobDownloadUrlProcedure.params, GetBlobDownloadUrlProcedure.returnType),
  __procedureSchema("get_blob_download_urls", GetBlobDownloadUrlsProcedure.params, GetBlobDownloadUrlsProcedure.returnType),
  __procedureSchema("get_render_upload_url", GetRenderUploadUrlProcedure.params, GetRenderUploadUrlProcedure.returnType),
  __procedureSchema("request_asset_ingestion", RequestAssetIngestionProcedure.params, RequestAssetIngestionProcedure.returnType),
  __procedureSchema("request_render", RequestRenderProcedure.params, RequestRenderProcedure.returnType),
  __procedureSchema("request_render_download_url", RequestRenderDownloadUrlProcedure.params, RequestRenderDownloadUrlProcedure.returnType),
);

type __SchemaWithTableAccessorAliases = Omit<typeof tablesSchema.schemaType, "tables"> & {
  tables: typeof tablesSchema.schemaType.tables & {
    /** @deprecated Use `assetAttribute` instead. This alias will be removed in the next major version. */
    readonly "asset_attribute": Omit<typeof tablesSchema.schemaType.tables["assetAttribute"], "accessorName"> & { readonly accessorName: "asset_attribute" };
    /** @deprecated Use `assetCanonicalNode` instead. This alias will be removed in the next major version. */
    readonly "asset_canonical_node": Omit<typeof tablesSchema.schemaType.tables["assetCanonicalNode"], "accessorName"> & { readonly accessorName: "asset_canonical_node" };
    /** @deprecated Use `assetChunkHashIndex` instead. This alias will be removed in the next major version. */
    readonly "asset_chunk_hash_index": Omit<typeof tablesSchema.schemaType.tables["assetChunkHashIndex"], "accessorName"> & { readonly accessorName: "asset_chunk_hash_index" };
    /** @deprecated Use `assetChunkStore` instead. This alias will be removed in the next major version. */
    readonly "asset_chunk_store": Omit<typeof tablesSchema.schemaType.tables["assetChunkStore"], "accessorName"> & { readonly accessorName: "asset_chunk_store" };
    /** @deprecated Use `assetCreatedEvent` instead. This alias will be removed in the next major version. */
    readonly "asset_created_event": Omit<typeof tablesSchema.schemaType.tables["assetCreatedEvent"], "accessorName"> & { readonly accessorName: "asset_created_event" };
    /** @deprecated Use `assetFileChunkRef` instead. This alias will be removed in the next major version. */
    readonly "asset_file_chunk_ref": Omit<typeof tablesSchema.schemaType.tables["assetFileChunkRef"], "accessorName"> & { readonly accessorName: "asset_file_chunk_ref" };
    /** @deprecated Use `assetFileRegisteredEvent` instead. This alias will be removed in the next major version. */
    readonly "asset_file_registered_event": Omit<typeof tablesSchema.schemaType.tables["assetFileRegisteredEvent"], "accessorName"> & { readonly accessorName: "asset_file_registered_event" };
    /** @deprecated Use `assetIngestionCompletedEvent` instead. This alias will be removed in the next major version. */
    readonly "asset_ingestion_completed_event": Omit<typeof tablesSchema.schemaType.tables["assetIngestionCompletedEvent"], "accessorName"> & { readonly accessorName: "asset_ingestion_completed_event" };
    /** @deprecated Use `assetMetadata` instead. This alias will be removed in the next major version. */
    readonly "asset_metadata": Omit<typeof tablesSchema.schemaType.tables["assetMetadata"], "accessorName"> & { readonly accessorName: "asset_metadata" };
    /** @deprecated Use `assetRenditionCreatedEvent` instead. This alias will be removed in the next major version. */
    readonly "asset_rendition_created_event": Omit<typeof tablesSchema.schemaType.tables["assetRenditionCreatedEvent"], "accessorName"> & { readonly accessorName: "asset_rendition_created_event" };
    /** @deprecated Use `assetRenditionNode` instead. This alias will be removed in the next major version. */
    readonly "asset_rendition_node": Omit<typeof tablesSchema.schemaType.tables["assetRenditionNode"], "accessorName"> & { readonly accessorName: "asset_rendition_node" };
    /** @deprecated Use `assetSceneNode` instead. This alias will be removed in the next major version. */
    readonly "asset_scene_node": Omit<typeof tablesSchema.schemaType.tables["assetSceneNode"], "accessorName"> & { readonly accessorName: "asset_scene_node" };
    /** @deprecated Use `assetScopeGrant` instead. This alias will be removed in the next major version. */
    readonly "asset_scope_grant": Omit<typeof tablesSchema.schemaType.tables["assetScopeGrant"], "accessorName"> & { readonly accessorName: "asset_scope_grant" };
    /** @deprecated Use `assetUploadCompletedEvent` instead. This alias will be removed in the next major version. */
    readonly "asset_upload_completed_event": Omit<typeof tablesSchema.schemaType.tables["assetUploadCompletedEvent"], "accessorName"> & { readonly accessorName: "asset_upload_completed_event" };
    /** @deprecated Use `assetUploadProgressCreatedEvent` instead. This alias will be removed in the next major version. */
    readonly "asset_upload_progress_created_event": Omit<typeof tablesSchema.schemaType.tables["assetUploadProgressCreatedEvent"], "accessorName"> & { readonly accessorName: "asset_upload_progress_created_event" };
    /** @deprecated Use `assetUser` instead. This alias will be removed in the next major version. */
    readonly "asset_user": Omit<typeof tablesSchema.schemaType.tables["assetUser"], "accessorName"> & { readonly accessorName: "asset_user" };
    /** @deprecated Use `assetVersionCreatedEvent` instead. This alias will be removed in the next major version. */
    readonly "asset_version_created_event": Omit<typeof tablesSchema.schemaType.tables["assetVersionCreatedEvent"], "accessorName"> & { readonly accessorName: "asset_version_created_event" };
    /** @deprecated Use `moduleUser` instead. This alias will be removed in the next major version. */
    readonly "module_user": Omit<typeof tablesSchema.schemaType.tables["moduleUser"], "accessorName"> & { readonly accessorName: "module_user" };
    /** @deprecated Use `orgModuleUser` instead. This alias will be removed in the next major version. */
    readonly "org_module_user": Omit<typeof tablesSchema.schemaType.tables["orgModuleUser"], "accessorName"> & { readonly accessorName: "org_module_user" };
    /** @deprecated Use `renderJob` instead. This alias will be removed in the next major version. */
    readonly "render_job": Omit<typeof tablesSchema.schemaType.tables["renderJob"], "accessorName"> & { readonly accessorName: "render_job" };
    /** @deprecated Use `renditionPreference` instead. This alias will be removed in the next major version. */
    readonly "rendition_preference": Omit<typeof tablesSchema.schemaType.tables["renditionPreference"], "accessorName"> & { readonly accessorName: "rendition_preference" };
    /** @deprecated Use `myAsset` instead. This alias will be removed in the next major version. */
    readonly "my_asset": Omit<typeof tablesSchema.schemaType.tables["myAsset"], "accessorName"> & { readonly accessorName: "my_asset" };
    /** @deprecated Use `myAssetFile` instead. This alias will be removed in the next major version. */
    readonly "my_asset_file": Omit<typeof tablesSchema.schemaType.tables["myAssetFile"], "accessorName"> & { readonly accessorName: "my_asset_file" };
    /** @deprecated Use `myAssetImportSettings` instead. This alias will be removed in the next major version. */
    readonly "my_asset_import_settings": Omit<typeof tablesSchema.schemaType.tables["myAssetImportSettings"], "accessorName"> & { readonly accessorName: "my_asset_import_settings" };
    /** @deprecated Use `myAssetIngestionRequests` instead. This alias will be removed in the next major version. */
    readonly "my_asset_ingestion_requests": Omit<typeof tablesSchema.schemaType.tables["myAssetIngestionRequests"], "accessorName"> & { readonly accessorName: "my_asset_ingestion_requests" };
    /** @deprecated Use `myAssetRendition` instead. This alias will be removed in the next major version. */
    readonly "my_asset_rendition": Omit<typeof tablesSchema.schemaType.tables["myAssetRendition"], "accessorName"> & { readonly accessorName: "my_asset_rendition" };
    /** @deprecated Use `myAssetUploadProgress` instead. This alias will be removed in the next major version. */
    readonly "my_asset_upload_progress": Omit<typeof tablesSchema.schemaType.tables["myAssetUploadProgress"], "accessorName"> & { readonly accessorName: "my_asset_upload_progress" };
    /** @deprecated Use `myAssetVersion` instead. This alias will be removed in the next major version. */
    readonly "my_asset_version": Omit<typeof tablesSchema.schemaType.tables["myAssetVersion"], "accessorName"> & { readonly accessorName: "my_asset_version" };
    /** @deprecated Use `myCurrentVersion` instead. This alias will be removed in the next major version. */
    readonly "my_current_version": Omit<typeof tablesSchema.schemaType.tables["myCurrentVersion"], "accessorName"> & { readonly accessorName: "my_current_version" };
  };
};

/** The remote SpacetimeDB module schema, both runtime and type information. */
const REMOTE_MODULE = {
  versionInfo: {
    cliVersion: "2.14.0" as const,
  },
  tables: tablesSchema.schemaType.tables as __SchemaWithTableAccessorAliases["tables"],
  reducers: reducersSchema.reducersType.reducers,
  ...proceduresSchema,
} satisfies __RemoteModule<
  __SchemaWithTableAccessorAliases,
  typeof reducersSchema.reducersType,
  typeof proceduresSchema
>;

const tableAccessorAliases = {
  "asset_attribute": "assetAttribute",
  "asset_canonical_node": "assetCanonicalNode",
  "asset_chunk_hash_index": "assetChunkHashIndex",
  "asset_chunk_store": "assetChunkStore",
  "asset_created_event": "assetCreatedEvent",
  "asset_file_chunk_ref": "assetFileChunkRef",
  "asset_file_registered_event": "assetFileRegisteredEvent",
  "asset_ingestion_completed_event": "assetIngestionCompletedEvent",
  "asset_metadata": "assetMetadata",
  "asset_rendition_created_event": "assetRenditionCreatedEvent",
  "asset_rendition_node": "assetRenditionNode",
  "asset_scene_node": "assetSceneNode",
  "asset_scope_grant": "assetScopeGrant",
  "asset_upload_completed_event": "assetUploadCompletedEvent",
  "asset_upload_progress_created_event": "assetUploadProgressCreatedEvent",
  "asset_user": "assetUser",
  "asset_version_created_event": "assetVersionCreatedEvent",
  "module_user": "moduleUser",
  "org_module_user": "orgModuleUser",
  "render_job": "renderJob",
  "rendition_preference": "renditionPreference",
  "my_asset": "myAsset",
  "my_asset_file": "myAssetFile",
  "my_asset_import_settings": "myAssetImportSettings",
  "my_asset_ingestion_requests": "myAssetIngestionRequests",
  "my_asset_rendition": "myAssetRendition",
  "my_asset_upload_progress": "myAssetUploadProgress",
  "my_asset_version": "myAssetVersion",
  "my_current_version": "myCurrentVersion",
} as const;

function __withTableAccessorAliases<T extends object>(target: T, freeze = false): T {
  const out = Object.create(Object.getPrototypeOf(target)) as T & Record<string, unknown>;
  Object.defineProperties(out, Object.getOwnPropertyDescriptors(target));
  for (const [deprecatedAccessor, targetAccessor] of Object.entries(tableAccessorAliases)) {
    if (deprecatedAccessor in out) {
      continue;
    }
    Object.defineProperty(out, deprecatedAccessor, {
      enumerable: true,
      configurable: false,
      get: () => out[targetAccessor],
    });
  }
  return freeze ? Object.freeze(out) : out;
}

type __DbViewBase = __DbConnectionImpl<typeof REMOTE_MODULE>["db"];
export type DbView = __DbViewBase & {
  /** @deprecated Use `assetAttribute` instead. This alias will be removed in the next major version. */
  readonly "asset_attribute": __DbViewBase["assetAttribute"];
  /** @deprecated Use `assetCanonicalNode` instead. This alias will be removed in the next major version. */
  readonly "asset_canonical_node": __DbViewBase["assetCanonicalNode"];
  /** @deprecated Use `assetChunkHashIndex` instead. This alias will be removed in the next major version. */
  readonly "asset_chunk_hash_index": __DbViewBase["assetChunkHashIndex"];
  /** @deprecated Use `assetChunkStore` instead. This alias will be removed in the next major version. */
  readonly "asset_chunk_store": __DbViewBase["assetChunkStore"];
  /** @deprecated Use `assetCreatedEvent` instead. This alias will be removed in the next major version. */
  readonly "asset_created_event": __DbViewBase["assetCreatedEvent"];
  /** @deprecated Use `assetFileChunkRef` instead. This alias will be removed in the next major version. */
  readonly "asset_file_chunk_ref": __DbViewBase["assetFileChunkRef"];
  /** @deprecated Use `assetFileRegisteredEvent` instead. This alias will be removed in the next major version. */
  readonly "asset_file_registered_event": __DbViewBase["assetFileRegisteredEvent"];
  /** @deprecated Use `assetIngestionCompletedEvent` instead. This alias will be removed in the next major version. */
  readonly "asset_ingestion_completed_event": __DbViewBase["assetIngestionCompletedEvent"];
  /** @deprecated Use `assetMetadata` instead. This alias will be removed in the next major version. */
  readonly "asset_metadata": __DbViewBase["assetMetadata"];
  /** @deprecated Use `assetRenditionCreatedEvent` instead. This alias will be removed in the next major version. */
  readonly "asset_rendition_created_event": __DbViewBase["assetRenditionCreatedEvent"];
  /** @deprecated Use `assetRenditionNode` instead. This alias will be removed in the next major version. */
  readonly "asset_rendition_node": __DbViewBase["assetRenditionNode"];
  /** @deprecated Use `assetSceneNode` instead. This alias will be removed in the next major version. */
  readonly "asset_scene_node": __DbViewBase["assetSceneNode"];
  /** @deprecated Use `assetScopeGrant` instead. This alias will be removed in the next major version. */
  readonly "asset_scope_grant": __DbViewBase["assetScopeGrant"];
  /** @deprecated Use `assetUploadCompletedEvent` instead. This alias will be removed in the next major version. */
  readonly "asset_upload_completed_event": __DbViewBase["assetUploadCompletedEvent"];
  /** @deprecated Use `assetUploadProgressCreatedEvent` instead. This alias will be removed in the next major version. */
  readonly "asset_upload_progress_created_event": __DbViewBase["assetUploadProgressCreatedEvent"];
  /** @deprecated Use `assetUser` instead. This alias will be removed in the next major version. */
  readonly "asset_user": __DbViewBase["assetUser"];
  /** @deprecated Use `assetVersionCreatedEvent` instead. This alias will be removed in the next major version. */
  readonly "asset_version_created_event": __DbViewBase["assetVersionCreatedEvent"];
  /** @deprecated Use `moduleUser` instead. This alias will be removed in the next major version. */
  readonly "module_user": __DbViewBase["moduleUser"];
  /** @deprecated Use `orgModuleUser` instead. This alias will be removed in the next major version. */
  readonly "org_module_user": __DbViewBase["orgModuleUser"];
  /** @deprecated Use `renderJob` instead. This alias will be removed in the next major version. */
  readonly "render_job": __DbViewBase["renderJob"];
  /** @deprecated Use `renditionPreference` instead. This alias will be removed in the next major version. */
  readonly "rendition_preference": __DbViewBase["renditionPreference"];
  /** @deprecated Use `myAsset` instead. This alias will be removed in the next major version. */
  readonly "my_asset": __DbViewBase["myAsset"];
  /** @deprecated Use `myAssetFile` instead. This alias will be removed in the next major version. */
  readonly "my_asset_file": __DbViewBase["myAssetFile"];
  /** @deprecated Use `myAssetImportSettings` instead. This alias will be removed in the next major version. */
  readonly "my_asset_import_settings": __DbViewBase["myAssetImportSettings"];
  /** @deprecated Use `myAssetIngestionRequests` instead. This alias will be removed in the next major version. */
  readonly "my_asset_ingestion_requests": __DbViewBase["myAssetIngestionRequests"];
  /** @deprecated Use `myAssetRendition` instead. This alias will be removed in the next major version. */
  readonly "my_asset_rendition": __DbViewBase["myAssetRendition"];
  /** @deprecated Use `myAssetUploadProgress` instead. This alias will be removed in the next major version. */
  readonly "my_asset_upload_progress": __DbViewBase["myAssetUploadProgress"];
  /** @deprecated Use `myAssetVersion` instead. This alias will be removed in the next major version. */
  readonly "my_asset_version": __DbViewBase["myAssetVersion"];
  /** @deprecated Use `myCurrentVersion` instead. This alias will be removed in the next major version. */
  readonly "my_current_version": __DbViewBase["myCurrentVersion"];
};

type __TablesBase = __QueryBuilder<typeof tablesSchema.schemaType>;
export type Tables = __TablesBase & {
  /** @deprecated Use `assetAttribute` instead. This alias will be removed in the next major version. */
  readonly "asset_attribute": __TablesBase["assetAttribute"];
  /** @deprecated Use `assetCanonicalNode` instead. This alias will be removed in the next major version. */
  readonly "asset_canonical_node": __TablesBase["assetCanonicalNode"];
  /** @deprecated Use `assetChunkHashIndex` instead. This alias will be removed in the next major version. */
  readonly "asset_chunk_hash_index": __TablesBase["assetChunkHashIndex"];
  /** @deprecated Use `assetChunkStore` instead. This alias will be removed in the next major version. */
  readonly "asset_chunk_store": __TablesBase["assetChunkStore"];
  /** @deprecated Use `assetCreatedEvent` instead. This alias will be removed in the next major version. */
  readonly "asset_created_event": __TablesBase["assetCreatedEvent"];
  /** @deprecated Use `assetFileChunkRef` instead. This alias will be removed in the next major version. */
  readonly "asset_file_chunk_ref": __TablesBase["assetFileChunkRef"];
  /** @deprecated Use `assetFileRegisteredEvent` instead. This alias will be removed in the next major version. */
  readonly "asset_file_registered_event": __TablesBase["assetFileRegisteredEvent"];
  /** @deprecated Use `assetIngestionCompletedEvent` instead. This alias will be removed in the next major version. */
  readonly "asset_ingestion_completed_event": __TablesBase["assetIngestionCompletedEvent"];
  /** @deprecated Use `assetMetadata` instead. This alias will be removed in the next major version. */
  readonly "asset_metadata": __TablesBase["assetMetadata"];
  /** @deprecated Use `assetRenditionCreatedEvent` instead. This alias will be removed in the next major version. */
  readonly "asset_rendition_created_event": __TablesBase["assetRenditionCreatedEvent"];
  /** @deprecated Use `assetRenditionNode` instead. This alias will be removed in the next major version. */
  readonly "asset_rendition_node": __TablesBase["assetRenditionNode"];
  /** @deprecated Use `assetSceneNode` instead. This alias will be removed in the next major version. */
  readonly "asset_scene_node": __TablesBase["assetSceneNode"];
  /** @deprecated Use `assetScopeGrant` instead. This alias will be removed in the next major version. */
  readonly "asset_scope_grant": __TablesBase["assetScopeGrant"];
  /** @deprecated Use `assetUploadCompletedEvent` instead. This alias will be removed in the next major version. */
  readonly "asset_upload_completed_event": __TablesBase["assetUploadCompletedEvent"];
  /** @deprecated Use `assetUploadProgressCreatedEvent` instead. This alias will be removed in the next major version. */
  readonly "asset_upload_progress_created_event": __TablesBase["assetUploadProgressCreatedEvent"];
  /** @deprecated Use `assetUser` instead. This alias will be removed in the next major version. */
  readonly "asset_user": __TablesBase["assetUser"];
  /** @deprecated Use `assetVersionCreatedEvent` instead. This alias will be removed in the next major version. */
  readonly "asset_version_created_event": __TablesBase["assetVersionCreatedEvent"];
  /** @deprecated Use `moduleUser` instead. This alias will be removed in the next major version. */
  readonly "module_user": __TablesBase["moduleUser"];
  /** @deprecated Use `orgModuleUser` instead. This alias will be removed in the next major version. */
  readonly "org_module_user": __TablesBase["orgModuleUser"];
  /** @deprecated Use `renderJob` instead. This alias will be removed in the next major version. */
  readonly "render_job": __TablesBase["renderJob"];
  /** @deprecated Use `renditionPreference` instead. This alias will be removed in the next major version. */
  readonly "rendition_preference": __TablesBase["renditionPreference"];
  /** @deprecated Use `myAsset` instead. This alias will be removed in the next major version. */
  readonly "my_asset": __TablesBase["myAsset"];
  /** @deprecated Use `myAssetFile` instead. This alias will be removed in the next major version. */
  readonly "my_asset_file": __TablesBase["myAssetFile"];
  /** @deprecated Use `myAssetImportSettings` instead. This alias will be removed in the next major version. */
  readonly "my_asset_import_settings": __TablesBase["myAssetImportSettings"];
  /** @deprecated Use `myAssetIngestionRequests` instead. This alias will be removed in the next major version. */
  readonly "my_asset_ingestion_requests": __TablesBase["myAssetIngestionRequests"];
  /** @deprecated Use `myAssetRendition` instead. This alias will be removed in the next major version. */
  readonly "my_asset_rendition": __TablesBase["myAssetRendition"];
  /** @deprecated Use `myAssetUploadProgress` instead. This alias will be removed in the next major version. */
  readonly "my_asset_upload_progress": __TablesBase["myAssetUploadProgress"];
  /** @deprecated Use `myAssetVersion` instead. This alias will be removed in the next major version. */
  readonly "my_asset_version": __TablesBase["myAssetVersion"];
  /** @deprecated Use `myCurrentVersion` instead. This alias will be removed in the next major version. */
  readonly "my_current_version": __TablesBase["myCurrentVersion"];
};

/** The tables available in this remote SpacetimeDB module. Each table reference doubles as a query builder. */
const tablesBase: __TablesBase = __makeQueryBuilder(tablesSchema.schemaType);
export const tables: Tables = __withTableAccessorAliases(tablesBase, true) as Tables;

/** The reducers available in this remote SpacetimeDB module. */
export const reducers = __convertToAccessorMap(reducersSchema.reducersType.reducers);

/** The procedures available in this remote SpacetimeDB module. */
export const procedures = __convertToAccessorMap(proceduresSchema.procedures);

/** The context type returned in callbacks for all possible events. */
export type EventContext = Omit<__EventContextInterface<typeof REMOTE_MODULE>, "db"> & { db: DbView };
/** The context type returned in callbacks for reducer events. */
export type ReducerEventContext = Omit<__ReducerEventContextInterface<typeof REMOTE_MODULE>, "db"> & { db: DbView };
/** The context type returned in callbacks for subscription events. */
export type SubscriptionEventContext = Omit<__SubscriptionEventContextInterface<typeof REMOTE_MODULE>, "db"> & { db: DbView };
/** The context type returned in callbacks for error events. */
export type ErrorContext = Omit<__ErrorContextInterface<typeof REMOTE_MODULE>, "db"> & { db: DbView };
/** The subscription handle type to manage active subscriptions created from a {@link SubscriptionBuilder}. */
export type SubscriptionHandle = __SubscriptionHandleImpl<typeof REMOTE_MODULE>;

/** Builder class to configure a new subscription to the remote SpacetimeDB instance. */
export class SubscriptionBuilder extends __SubscriptionBuilderImpl<typeof REMOTE_MODULE> {}

/** Builder class to configure a new database connection to the remote SpacetimeDB instance. */
export class DbConnectionBuilder extends __DbConnectionBuilder<DbConnection> {}

/** The typed database connection to manage connections to the remote SpacetimeDB instance. This class has type information specific to the generated module. */
export class DbConnection extends __DbConnectionImpl<typeof REMOTE_MODULE> {
  declare db: DbView;

  constructor(config: __DbConnectionConfig<typeof REMOTE_MODULE>) {
    super(config);
    this.db = __withTableAccessorAliases(this.db) as DbView;
  }

  /** Creates a new {@link DbConnectionBuilder} to configure and connect to the remote SpacetimeDB instance. */
  static builder = (): DbConnectionBuilder => {
    return new DbConnectionBuilder(REMOTE_MODULE, (config: __DbConnectionConfig<typeof REMOTE_MODULE>) => new DbConnection(config));
  };

  /** Creates a new {@link SubscriptionBuilder} to configure a subscription to the remote SpacetimeDB instance. */
  override subscriptionBuilder = (): SubscriptionBuilder => {
    return new SubscriptionBuilder(this);
  };
}

